import ReplaceReservationWarning from './replace_reservation_warning';

export default ReplaceReservationWarning;
